import clsx from 'clsx';

type TColumnContainerProps = {
  children: React.ReactNode;
  className?: string;
};

export function ColumnContainer({ children, className }: TColumnContainerProps) {
  return <div className={clsx('flex w-full flex-col gap-3', className)}>{children}</div>;
}
